import { useState, useEffect } from "react";

import Select, { Options } from "react-select";
import { connection } from "../../utils/apiConnection.ts";
import { translateToProductReactSelect1 } from "../../utils/helperFunctions.js";

import { RiDeleteBin5Fill } from "react-icons/ri";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import toast from "react-hot-toast";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { useParams } from "react-router-dom";

export default function EditSpecialBasketModal({
  selectedBasket,
  updater,
  setUpdater
}) {
  const [productList, setProductList] = useState([]);
  const [selected, setSelected] = useState({
    label: "کالای مورد نظر را خود را جستجو کنید",
    value: "",
    price: "",
    total_inventory: ""
  });
  const [selectedOption, setSelectedOption] = useState({});
  const [addToBasket, setAddToBasket] = useState({
    count: "",
    product_title: "",
    avb_product_for_order__id: "",
    price: "",
    path: "",
    available_order_option_ids: []
    // options: []
  });

  const [basketItems, setBasketItems] = useState([]);
  const [basketSupplier, setBasketSupplier] = useState({});

  useEffect(() => {
    setBasketItems(
      selectedBasket.basket_items ? selectedBasket.basket_items : []
    );
  }, [selectedBasket.basket_items]);

  useEffect(() => {
    if (selectedBasket != "") {
      setBasketSupplier(selectedBasket.basket_supplier);
    }
  }, [selectedBasket]);

  let supplierId = useParams();

  useEffect(() => {
    // const formData1 = new FormData();
    // formData1.append("supplier_id", 1);
    connection(
      "api/get_products"
      // , {
      // supplier_id: supplierId.supplier_id
      // supplier_id: 1
      // }
    ).then(data => {
      setProductList(data.data);
    });
  }, []);

  function inputChangeHandler(event: Event, isNumber: boolean = false) {
    // let value: string = removeCommas(event.target.value),
    let value: string = event.target.value,
      name: string = event.target.name;
    try {
      if (isNumber) {
        value = removeCommas(value);
        if (isNaN(value)) {
          throw new Error("لطفا عدد را به درستی وارد نمایید.");
        }
        value = +value;
      }
      let tName = name.toLowerCase();

      if (tName === "total_discount" && +priceCounter() < value)
        throw new Error("تخفیف نمیتواند از قیمت بیشتر باشد.");
      //   if (tName === "price" && selected.discount > value)
      //     throw new Error("قیمت نمیتواند از تخفیف کمتر باشد.");

      // setBasket(prev => ({ ...prev, [name]: value }));
      setBasketSupplier(prev => ({ ...prev, [name]: value }));
    } catch (ex) {
      toast.error(ex.message);
    }
  }
  function inputChangeHandler1(event: Event, isNumber: boolean = false) {
    let value: string = event.target.value,
      name: string = event.target.name;
    try {
      if (isNumber && isNaN(value))
        throw new Error("لطفا عدد را به درستی وارد نمایید.");
      value = +value;
      let tName = name.toLowerCase();
      if (tName === "count" && selected.total_inventory < value)
        throw new Error(" تعداد نمیتواند از موجودی بیشتر باشد.");
      console.log(selected.total_inventory, "selected.total_inventory");
      setAddToBasket(prev => ({ ...prev, [name]: value }));
    } catch (ex) {
      toast.error(ex.message);
    }
  }
  const [validationProduct, setValidationProduct] = useState({
    productName: true,
    productNumber: true
  });
  const validation = () => {
    let isValid = true;
    if (addToBasket.product_title == "") {
      setValidationProduct(prev => {
        return { ...prev, productName: false };
      });
      isValid = false;
    } else {
      setValidationProduct(prev => {
        return { ...prev, productName: true };
      });
    }

    if (addToBasket.count == "") {
      setValidationProduct(prev => {
        return { ...prev, productNumber: false };
      });
      isValid = false;
    } else {
      setValidationProduct(prev => {
        return { ...prev, productNumber: true };
      });
    }
    return isValid;
  };
  const addItem = () => {
    console.log("add basket1000 : ", addToBasket);
    console.log("add basket  5000 : ", selectedOption);

    for (let i = 0; i < selectedOption.length; i++) {
      if (selectedOption[i].status == true) {
        addToBasket.available_order_option_ids.push(selectedOption[i]);
      }
    }

    basketItems.push(addToBasket);
    setAddToBasket({
      count: "",
      product_title: "",
      price: "",
      available_order_option_ids: [],
      // options: [],
      avb_product_for_order__id: ""
    });
    setSelected({
      label: "کالای مورد نظر را خود را جستجو کنید",
      value: "",
      price: ""
    });

    setSelectedOption({});

    if (basketItems.length > 0) {
      toast.success("به لیست اضافه شد!");
    }
  };

  function productImageHandler(names, value) {
    setBasketSupplier(prev => {
      return {
        ...prev,
        [names]: value
      };
    });
  }
  const timeCounter = () => {
    let time = 0;

    for (let i = 0; i < basketItems.length; i++) {
      let x = basketItems[i].available_order_option_ids;
      if (x.length > 0) {
        try {
          x = JSON.parse(x);
        } catch (err) {}
      }

      for (let j = 0; j < x.length; j++) {
        if (x[j].default_need_time != "") {
          time += parseInt(x[j].default_need_time) / 60;
        } else {
          time = 0;
        }
      }
    }
    return time;
  };
  const productCounter = () => {
    let productCount = 0;
    for (let i = 0; i < basketItems.length; i++) {
      productCount += +basketItems[i].count;
    }
    return productCount;
  };

  const priceCounter = () => {
    let totalPrice = 0;
    for (let i = 0; i < basketItems.length; i++) {
      totalPrice += +basketItems[i].price * +basketItems[i].count;

      let x = basketItems[i].available_order_option_ids;
      if (x.length > 0) {
        try {
          x = JSON.parse(x);
        } catch (err) {}
      }

      for (let j = 0; j < x.length; j++) {
        if (x[j].default_need_time != "") {
          totalPrice += parseInt(x[j].default_price);
        }
      }
    }
    // totalPrice = totalPrice - +basketSupplier.total_discount;
    return totalPrice;
  };
  const priceCounter2 = () => {
    let totalPrice = 0;
    for (let i = 0; i < basketItems.length; i++) {
      totalPrice += +basketItems[i].price * basketItems[i].count;
    }
    return +totalPrice;
  };
  const [validationBasket, setValidationBasket] = useState({
    basketTitle: true,
    basketItems: true
  });
  const basketValidation = () => {
    let isValid = true;
    if (basketItems.title == "") {
      setValidationBasket(prev => {
        return { ...prev, basketTitle: false };
      });
      isValid = false;
    } else {
      setValidationBasket(prev => {
        return { ...prev, basketTitle: true };
      });
    }

    if (basketItems.length < 2) {
      setValidationBasket(prev => {
        return { ...prev, basketItems: false };
      });
      isValid = false;
    } else {
      setValidationBasket(prev => {
        return { ...prev, basketItems: true };
      });
    }
    return isValid;
  };

  const createBasket = () => {
    let fd = {
      // supplier_id: supplierId.supplier_id,
      supplier_id: basketSupplier.supplier_id,
      basket_id: basketSupplier.ready_to_order_basket__id,
      basket_file: basketSupplier.path,
      basket_title: basketSupplier.title,
      basket_description: basketSupplier.description,
      basket_total_price: priceCounter(),
      basket_price: priceCounter2(),
      basket_order_limit: basketSupplier.basket_order_limit
        ? basketSupplier.basket_order_limit
        : "",
      basket_discount: basketSupplier.total_discount,
      items_count: basketItems.length
    };
    console.log("basket", basketItems);
    for (let i = 0; i < basketItems.length; i++) {
      let pprice = basketItems[i].price;
      if (basketItems[i].options && basketItems[i].options instanceof Array) {
        pprice += basketItems[i].options.reduce((total, value) => {
          return total + value.default_price;
        }, 0);
      }
      fd[`count_${i}`] = basketItems[i].count;
      fd[`price_${i}`] = pprice;
      fd[`product_price_${i}`] = basketItems[i].price;
      fd[`avb_product_for_order__id_${i}`] =
        basketItems[i].avb_product_for_order__id;
      fd[`selected_aoos_ids_${i}`] = basketItems[i].available_order_option_ids;
    }
    connection("supplier/reg_edit_basket", fd).then(data => {
      document.querySelector("#editBasketBtn").disabled = true;
      if (data.status == 1) {
        setUpdater(prev => {
          return !prev;
        });
        setBasketSupplier({
          basket_file: ""
        });
        toast.success("اطلاعات سبد با موفقیت ویرایش شد.");
        document.querySelector("#editBasketBtn").disabled = false;
        document.querySelector("#editSpecialBasketModal .btn-close").click();
      } else {
        document.querySelector("#editBasketBtn").disabled = false;
        toast.error("در ویرایش سبد مشکلی به وجود آمده است!");
      }
    });
  };
  const optionMaker = value => {
    let x = value.available_order_option_ids;
    try {
      x = JSON.parse(x);
    } catch (err) {}
    return x.map(value1 => {
      return (
        <div className="flex-grow-1">
          <div className="p-3 text-center fs-14">{value1.title}</div>
          <div className="p-3 text-center">
            {value1.default_price} تومان - {value1.default_need_time / 60} دقیقه
          </div>
        </div>
      );
    });
  };

  return (
    <div
      className="modal fade"
      id="editSpecialBasketModal"
      tabIndex={-1}
      aria-labelledby="editSpecialBasketModalLabel"
      style={{ zIndex: "1061" }}
      //   aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-body">
            <div
              className="d-flex justify-content-between mx-4 mt-5 pb-3"
              style={{ borderBottom: "2px solid gray" }}
            >
              <h5> ویرایش سبد</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="edit-basket mt-5">
              <ul className="nav nav-tabs mx-4" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home"
                    type="button"
                    role="tab"
                    aria-controls="home"
                    aria-selected="true"
                  >
                    اقلام سبد
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#profile"
                    type="button"
                    role="tab"
                    aria-controls="profile"
                    aria-selected="false"
                  >
                    اطلاعات سبد
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <form className="px-4 form1 mt-5">
                    <div className="mb-4 " style={{ minWidth: "150px" }}>
                      <Select
                        placeholder={
                          <div className="d-flex justify-content-between py-2">
                            <div>کالای مورد نظر را جستجو کنید</div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="28.099"
                              height="28.007"
                              viewBox="0 0 28.099 28.007"
                            >
                              <path
                                id="Icon_ionic-ios-search"
                                data-name="Icon ionic-ios-search"
                                d="M31.184,29.545l-7.509-7.58a10.7,10.7,0,1,0-1.624,1.645l7.46,7.53a1.156,1.156,0,0,0,1.631.042A1.163,1.163,0,0,0,31.184,29.545ZM15.265,23.7a8.45,8.45,0,1,1,5.977-2.475A8.4,8.4,0,0,1,15.265,23.7Z"
                                transform="translate(-4 -3.993)"
                                fill="#1a3764"
                                stroke="#1a3764"
                                stroke-width="1"
                              />
                            </svg>
                          </div>
                        }
                        options={
                          productList &&
                          selectedBasket.basket_items &&
                          translateToProductReactSelect1(
                            productList.filter(value1 => {
                              return (
                                selectedBasket.basket_items.findIndex(
                                  val =>
                                    val.avb_product_for_order__id ==
                                    value1.info.avb_product_for_order__id
                                ) === -1
                              );
                            }),
                            // productList,
                            false
                          )
                        }
                        value={selected}
                        onChange={e => {
                          setSelected(e);
                          setSelectedOption(() => {
                            let temp = [...e.option];
                            for (let i = 0; i < e.option.length; i++) {
                              temp[i] = { ...temp[i], status: false };
                            }
                            return temp;
                          });
                          setAddToBasket(prev => {
                            return {
                              ...prev,
                              product_title: e.label,
                              price: e.price,
                              path: e.image ? e.image : e.image2,
                              avb_product_for_order__id: e.value,
                              total_inventory: e.total_inventory
                            };
                          });
                        }}
                        classNamePrefix="select-box"
                      />
                      <p
                        className={`text-danger ${
                          validationProduct.productName == false
                            ? "d-block"
                            : "d-none"
                        }`}
                        style={{ fontSize: "12px" }}
                      >
                        این فیلد نمی تواند خالی باشد
                      </p>
                    </div>

                    <div className="d-flex align-items-center">
                      <label>قیمت : </label>
                      <p
                        className="rounded bg-light mx-3 p-2"
                        style={{
                          width: "100px",
                          height: "40px"
                        }}
                      >
                        {addCommas(selected.price)}
                      </p>
                      <span>تومان</span>
                    </div>

                    {selectedOption.length > 0 &&
                      selectedOption.map((value1, index1) => {
                        return (
                          <div className="d-flex align-items-center mx-3">
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={value1.status}
                                className="form-check-input"
                                key={index1}
                                onChange={() => {
                                  setSelectedOption(prev => {
                                    let temp = [...prev];
                                    temp[index1].status = !selectedOption[
                                      index1
                                    ].status;
                                    return temp;
                                  });

                                  console.log(
                                    "selected option : ",
                                    selectedOption
                                  );
                                  console.log("add bas2", addToBasket);
                                }}
                              />
                              <span class="slider round"></span>
                            </label>

                            <div className="d-flex flex-wrap justify-content-between align-items-center w-100  mt-1">
                              <div className="mx-3">{value1.title}</div>
                              <div className="d-flex">
                                <input
                                  type="text"
                                  className="form-control product-option-input"
                                  value={addCommas(value1.default_price)}
                                  style={{ width: "80px" }}
                                />
                                <span className="mx-2">تومان</span>
                                <input
                                  type="text"
                                  className="form-control product-option-input"
                                  style={{ width: "55px" }}
                                  value={value1.default_need_time / 60}
                                />
                                <span className="mx-2">دقیقه</span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    <div className="d-flex flex-wrap justify-content-between">
                      <div className="d-flex mx-3 align-items-center mt-3 ">
                        <label htmlFor="count" className="">
                          تعداد
                        </label>
                        <div className="">
                          <input
                            type="text"
                            id="count"
                            className="form-control mx-2 "
                            style={{ width: "70px" }}
                            value={addToBasket.count}
                            name="count"
                            onChange={e => {
                              inputChangeHandler1(e, true);
                              console.log("addBasket 3 : ", addToBasket);
                            }}
                          />
                          <p
                            className={`text-danger  ${
                              validationProduct.productNumber == false
                                ? "d-block"
                                : "d-none"
                            }`}
                            style={{ fontSize: "12px" }}
                          >
                            این فیلد نمی تواند خالی باشد
                          </p>
                        </div>
                      </div>

                      <div className="btn-addlist mx-3 mt-3">
                        <button
                          type="button"
                          className="btn btn-success px-3"
                          onClick={e => {
                            e.preventDefault();
                            if (validation()) {
                              addItem();
                            }
                          }}
                        >
                          اضافه به لیست
                        </button>
                      </div>
                    </div>
                  </form>
                  {basketItems.length > 0 &&
                    basketItems.map((value, index) => {
                      return (
                        <div
                          className="d-flex flex-row flex-wrap  shadow mt-5"
                          style={{
                            borderRadius: "10px",
                            overflow: "hidden"
                            // border: "1px solid #ff4734"
                          }}
                        >
                          <div className="flex-grow-1">
                            <div
                              className="p-1 text-center fs-14 bg-orange text-white"
                              style={{
                                borderRadius: "0 10px 0 0"
                              }}
                            >
                              عکس
                            </div>
                            <div className="text-center m-2">
                              <img
                                style={{
                                  width: "70px",
                                  minHeight: "40px",
                                  borderRadius: "7px"
                                }}
                                // src={`http://sabadi.tatdemo.ir/${value.productImage}`}
                                src={`http://sabadi.tatdemo.ir/${value.path}`}
                              />
                            </div>
                          </div>

                          <div className="flex-grow-1">
                            <div className="p-1 text-center fs-14 bg-orange text-white">
                              نام کالا
                            </div>
                            <div className="p-1 text-center">
                              {value.product_title}
                            </div>
                          </div>

                          <div className="flex-grow-1">
                            <div className="p-1 text-center fs-14 bg-orange text-white">
                              تعداد
                            </div>
                            <div className="p-1 text-center">{value.count}</div>
                          </div>

                          <div className="flex-grow-1">
                            <div className="p-1 text-center fs-14 bg-orange text-white">
                              قیمت واحد(تومان)
                            </div>
                            <div className="p-1 text-center">
                              {addCommas(value.price)}
                            </div>
                          </div>

                          <div className="flex-grow-1">
                            <div className="p-1 text-center fs-14 bg-orange text-white">
                              قیمت کل(تومان)
                            </div>
                            <div className="p-1 text-center">
                              {addCommas(value.price * value.count)}
                            </div>
                          </div>

                          {/* {JSON.parse(value.available_order_option_ids).length > */}
                          {value.available_order_option_ids.length > 0 &&
                            optionMaker(value)}
                          <div className="flex-grow-1">
                            <div className="p-1  text-center fs-14 bg-orange text-white">
                              عملیات
                            </div>
                            <div className="p-1 text-center">
                              <button
                                className="btn text-danger"
                                onClick={() => {
                                  setBasketItems(
                                    basketItems.filter((value, index1) => {
                                      return index1 != index;
                                    })
                                  );
                                  // if(priceCounter()<basketSupplier.total_discount){
                                  setBasketSupplier(prev => {
                                    return { ...prev, total_discount: 0 };
                                  });
                                  // }
                                }}
                              >
                                <RiDeleteBin5Fill />
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
                <div
                  class="tab-pane fade"
                  id="profile"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div>
                    <div
                      className="mt-5 mx-3 shadow px-3 pt-4 "
                      style={{ borderRadius: "20px" }}
                    >
                      <h6>کاور سبد :</h6>

                      {basketSupplier == undefined ? (
                        ""
                      ) : (
                        <form>
                          <input
                            type="file"
                            className="form-control my-3"
                            onChange={e => {
                              productImageHandler("path", e.target.files[0]);
                              console.log("iamge basket", basketSupplier.path);
                              console.log("iamge basket2", e.target.files[0]);
                            }}
                          />
                          <Form.Floating className="">
                            <Form.Control
                              id="basket-title"
                              type="text"
                              placeholder="عنوان سبد"
                              name="title"
                              value={basketSupplier.title}
                              onChange={e => {
                                console.log(e.target.value);
                                inputChangeHandler(e, false);
                              }}
                            />
                            <label htmlFor="basket-title">عنوان سبد</label>
                          </Form.Floating>
                          <p
                            className={`text-danger ${
                              validationBasket.basketTitle == false
                                ? "d-block"
                                : "d-none"
                            }`}
                            style={{ fontSize: "12px" }}
                          >
                            این فیلد نمی تواند خالی باشد
                          </p>

                          <FloatingLabel className="mt-3" label="توضیحات سبد">
                            <Form.Control
                              as="textarea"
                              id="basket-description"
                              name="description"
                              placeholder="توضیحات سبد"
                              style={{ height: "100px" }}
                              value={basketSupplier.description}
                              onChange={e => {
                                inputChangeHandler(e, false);
                              }}
                            />
                          </FloatingLabel>
                          {}
                          <Form.Floating className="mt-3">
                            <Form.Control
                              id="special-discount"
                              name="total_discount"
                              type="text"
                              placeholder="تخفیف ویژه"
                              value={addCommas(basketSupplier.total_discount)}
                              // defaultValue={0}
                              onChange={e => {
                                inputChangeHandler(e, true);
                              }}
                            />
                            <label htmlFor="special-discount">
                              تخفیف ویژه(تومان)
                            </label>
                          </Form.Floating>

                          <Form.Floating className="mt-3">
                            <Form.Control
                              id="order-limit"
                              type="text"
                              name="basket_order_limit"
                              placeholder="تعداد "
                              // defaultValue={1}
                              value={basketSupplier.basket_order_limit}
                              onChange={e => {
                                inputChangeHandler(e, true);
                              }}
                            />
                            <label htmlFor="order-limit"> حداکثر سفارش</label>
                          </Form.Floating>
                          {/* </div> */}
                          <p
                            className={`text-danger fs-12 ${
                              validationBasket.basketTitle == false
                                ? "d-block"
                                : "d-none"
                            }`}
                            style={{ fontSize: "12px" }}
                          >
                            این فیلد نمی تواند خالی باشد
                          </p>

                          <div className="d-flex mt-3">
                            <Form.Floating>
                              <Form.Control
                                id="floatingPasswordCustom"
                                type="text"
                                placeholder="تعداد آیتم ها"
                                value={basketItems.length}
                                readOnly
                              />
                              <label htmlFor="floatingPasswordCustom">
                                تعداد آیتم ها
                              </label>
                            </Form.Floating>

                            <Form.Floating className="mx-3">
                              <Form.Control
                                id="floatingPasswordCustom"
                                type="text"
                                placeholder="تعداد کالاها"
                                value={productCounter()}
                                readOnly
                              />
                              <label htmlFor="floatingPasswordCustom">
                                تعداد کالاها
                              </label>
                            </Form.Floating>
                          </div>
                          <p
                            className={`text-danger fs-12 ${
                              validationBasket.basketItems == false
                                ? "d-block"
                                : "d-none"
                            }`}
                            style={{ fontSize: "12px" }}
                          >
                            حداقل 2 محصول برای ایجاد سبد انتخاب کنید
                          </p>

                          <Form.Floating className="mt-3">
                            <Form.Control
                              id="floatingPasswordCustom"
                              type="text"
                              placeholder="حداقل زمان آماده سازی - دقیقه"
                              // value={counter.time}
                              value={timeCounter()}
                              disabled
                            />
                            <label htmlFor="floatingPasswordCustom">
                              حداقل زمان آماده سازی - دقیقه
                            </label>
                          </Form.Floating>

                          <Form.Floating className="mt-3 mb-5">
                            <Form.Control
                              id="floatingPasswordCustom"
                              type="text"
                              placeholder="مبلغ قابل پرداخت"
                              value={addCommas(
                                priceCounter() - basketSupplier.total_discount
                              )}
                              readOnly
                            />
                            <label htmlFor="floatingPasswordCustom">
                              مبلغ قابل پرداخت(تومان)
                            </label>
                          </Form.Floating>
                          <div className="text-end mx-3 pb-5">
                            <button
                              type="button"
                              id="editBasketBtn"
                              className="btn btn-lg btn-success px-3 "
                              onClick={e => {
                                e.preventDefault();
                                if (basketValidation()) {
                                  createBasket();
                                }
                              }}
                            >
                              ویرایش سبد
                            </button>
                          </div>
                        </form>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
